const disableScroll = () => document.body.classList.add('no_scroll');

export default disableScroll;
